import { render, staticRenderFns } from "./NoticeCard.vue?vue&type=template&id=45d22c72&"
import script from "./NoticeCard.vue?vue&type=script&lang=js&"
export * from "./NoticeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports